import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';

class MigrateService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
      isMigrating: false,
      isComplete: false,
      progress: 0,
    });
  }

  poolProgress = action(() => {
    const interval = setInterval(() => {
      this.fetch
        .fetch({
          method: 'get',
          url: '/migrate',
        })
        .then(() => {
          if (this.fetch.data) {
            this.progress = this.fetch.data.migrationProgress;
            if (this.fetch.data.apiVersion === 'V2') {
              clearInterval(interval);
              this.isComplete = true;
              localStorage.clear();
            }
          }
        });
    }, 2000);
  });

  init = action(() => {
    this.fetch
      .fetch({
        method: 'get',
        url: '/migrate',
      })
      .then(() => {
        if (this.fetch.data) {
          if (!this.fetch.data.apiVersion && this.fetch.data.migrationProgress) {
            this.isOpen = true;
            this.isMigrating = true;
            this.progress = this.fetch.data.migrationProgress;
            this.poolProgress();
          }
          if (!this.fetch.data.apiVersion && !this.fetch.data.migrationProgress) {
            this.isOpen = true;
          }
        }
        if (this.fetch.error) {
          this.isOpen = false;
          this.isMigrating = false;
          this.isComplete = false;
          this.progress = 0;
        }
      });
  });

  startMigrate = action(() => {
    this.fetch
      .fetch({
        method: 'put',
        url: '/migrate',
      })
      .then(() => {
        if (this.fetch.data) {
          this.isMigrating = true;
          this.progress = this.fetch.data.migrationProgress;
          this.poolProgress();

          NotificationService.addNotification('Migration in progress.', 'success');
        }
        if (this.fetch.error) {
          this.isMigrating = false;
          this.progress = 0;

          NotificationService.addNotification('Unable to migrate. Please check with our support team.', 'error');
        }
      });
  });

  handleClose = action(() => {
    this.isOpen = false;
    this.isMigrating = false;
  });
}

const migrateService = new MigrateService();
export default migrateService;
